module.exports = __webpack_public_path__ + "img/folder.6a38224.png";